<div class="clearfix">
  <div class="col-12 md:col-12"><h3>{{'Mg_Query' | translate}}</h3>
  <p-tabView  [controlClose]="true" (onChange)="handleChange($event)" (onClose)="closeTab($event)" [activeIndex]="index">
    <p-tabPanel [header]="'List' | translate"  [selected]="0 == index" [headerStyle]="{'font-weight':'bold'}">
      <div class="table-tools">
        @if (isAdmin || allowRequest) {
          <button (click)="goRequest()" class="p-button p-component p-button-text-only btn-square margin">
            {{'Srch_Idx' | translate}}
          </button>
        }
        <button (click)="add($event)" class="p-button p-component p-button-text-only btn-square">
          {{'Add_Query' | translate}}
        </button>
      </div>
      <br class="col-12 md:col-12">
      <p-table #dt  [selectionMode]="'single'" [columns]="listColumns" [value]="requests" [rows]="100"
        [paginator]="true" responsiveLayout="stack" [breakpoint]="'960px'"  (onRowSelect)="showDetails($event)" (onFilter)="setFilteredList($event)" [sortField]="'name'" >
        <ng-template pTemplate="caption">
          <span class="header-grid-wrapper">
            <span class="align-right">{{'Tot' | translate}} {{requests.length}} {{'Query_1' | translate}}</span>
          </span>
        </ng-template>
        <ng-template let-columns pTemplate="header">
          <tr>
            <th [pSortableColumn]="columns[0].field" class="width-auto">
              <p-sortIcon [field]="columns[0].field"></p-sortIcon>{{columns[0].header}}
              <input (click)="$event.stopPropagation()" pInputText type="text" (input)="dt.filter($event.target.value, columns[0].field, 'contains')"
                style="color: darkgrey;">
            </th>
            <th class="width-auto">
              {{columns[1].header}}
              <p-dropdown
                [options]="visibilityList"
                [style]="{ width: '100%' }"
                (onChange)="dt.filter($event.value, columns[1].field, 'equals')"
              ></p-dropdown>
            </th>
            <th [pSortableColumn]="columns[2].field" class="width-auto">
              <p-sortIcon [field]="columns[2].field"></p-sortIcon>{{columns[2].header}}
              <input (click)="$event.stopPropagation()" pInputText type="text" (input)="dt.filter($event.target.value, columns[2].field, 'contains')"
                style="color: darkgrey;">
            </th>
          </tr>
        </ng-template>
        <ng-template let-rowData let-columns="columns" pTemplate="body">
          <tr [pSelectableRow]="rowData">
            <td class="width-auto">
              {{rowData[columns[0].field]}}
            </td>
            <td class="width-auto">
              <visibility [value]="rowData[columns[1].field]"></visibility>
            </td>
            <td class="width-auto">
              {{rowData[columns[2].field]}}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7">{{'Empty' | translate}}</td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>
      @for (item of itemsSelected; track item; let i = $index) {
        <p-tabPanel header="{{item._label}}" [selected]="i == index -1"  [closable]="true">
          @if (item.id===-1) {
            <app-add-requests
              [indexList] = "indexList"
              [systemList] = "systemList"
              [propertiesList] = "propertiesList"
              [propBskList] = "propBskList"
              [editorList]="editorList"
              [groupList]="groupList"
              [userList]="userList"
              [resultList]="resultList"
              (onCancel)="cancelAdd($event)"
              (onValidate)="addTab($event)">
            </app-add-requests>
          }
          @if (item.id!==-1) {
            <app-edit-requests
              [indexList] = "indexList"
              [systemList] = "systemList"
              [propertiesList] = "propertiesList"
              [propBskList] = "propBskList"
              [editorList]="editorList"
              [groupList]="groupList"
              [userList]="userList"
              [resultList]="resultList"
              [item]="item"
              (onCancel)="closeTab($event)"
              (onValidate)="validateTab($event)"
              (onDeleteItem)="confirmDelete($event)">
            </app-edit-requests>
          }
        </p-tabPanel>
      }
    </p-tabView>
  </div>
</div>

<app-item-confirm
  [key]="'delete'"
  [severity]="'alert'"
  (onAccept)="delete($event)"
></app-item-confirm>
